import { Card, FC, Link, useEffect, useMemo } from 'external/react'
import useParent from 'context/parent-context/hook'

import Icon, { IconName } from 'external/fortawesome'
import { clsx } from 'external/clsx'
import SelectUserRole from './SelectUserRole'

import useFormValidation, { validators } from 'utilities/form-validation'
import { emptyUser } from 'types/context/parent'
import NewUserForm from './NewUserForm'

const {createRequiredFieldValidation, createEmailValidation} = validators

const addUserValidations = {
	first_name: [createRequiredFieldValidation('first_name')],
	last_name: [createRequiredFieldValidation('last_name')],
	email: [createRequiredFieldValidation('email'), createEmailValidation('email')]
}

const NewUser:FC = () => {

    const {navigation, update, state: {modals}, params: {role}, addUser} = useParent()
	const [errors, validate, resetValidations] = useFormValidation(addUserValidations);

    const [roleText, roleIcon] = useMemo(() => (
        (role === 'student')
            ? ['Estudiante', 'faGraduationCap']
            : ['Tutor', 'faPersonChalkboard']
        ) as [string, IconName], [role])
		
	function handleAddUser (e) {
		if (!validate(modals.addUser, true)) {
			e.preventDefault();
			return;
		}
		addUser(modals.addUser)
	}

	useEffect(() => {
		if (!navigation.newUser.active) {
			resetValidations()
			update({modals: {addUser: {$shallow: emptyUser}}})
		}
	}, [navigation.newUser.active])

	return (
        <>
        <Card.Body className='d-flex'>
			<NewUserForm errors={errors} />
			<SelectUserRole />
        </Card.Body>
        <Card.Footer className='py-2 d-flex justify-content-end pl-0'>
            <Link to={navigation.users.link()} onClick={handleAddUser} style={{ width: '200px' }} className={clsx('language__filter p-2 mt-2 button')}>
                <Icon name={roleIcon} /> Añadir {roleText}
            </Link>
        </Card.Footer>
        </>
	)
}

export {NewUser as default}